var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "confirm-page" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.pageDataFetched
        ? _c(
            "div",
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "relative" }, [
                _c("img", {
                  staticClass: "w-full object-cover h-full",
                  attrs: { src: _vm.bannerURL },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "child text-center" }, [
                  _c("img", {
                    staticClass: "m-auto",
                    attrs: { src: _vm.checkImage },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "font-medium text-5xl pt-1" }, [
                    _vm._v(_vm._s(this.header)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pt-1" }, [
                    _vm._v(_vm._s(this.bodyHeader)),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }